import { SubscriptionType, SubscriptionPlan, SubscriptionLimits } from '../types/subscription';

export { SubscriptionType };

export const SUBSCRIPTION_LIMITS: Record<SubscriptionType, SubscriptionLimits> = {
  [SubscriptionType.FREE]: {
    maxPets: 1,
    maxLogs: 2,
    maxAiChats: 2,
    maxReminders: 1
  },
  [SubscriptionType.PREMIUM_MONTHLY]: {
    maxPets: Infinity,
    maxLogs: Infinity,
    maxAiChats: Infinity,
    maxReminders: Infinity
  },
  [SubscriptionType.PREMIUM_YEARLY]: {
    maxPets: Infinity,
    maxLogs: Infinity,
    maxAiChats: Infinity,
    maxReminders: Infinity
  },
  [SubscriptionType.DR_VICTORIA]: {
    maxPets: Infinity,
    maxLogs: Infinity,
    maxAiChats: Infinity,
    maxReminders: Infinity
  },
  [SubscriptionType.GUEST]: {
    maxPets: Infinity,
    maxLogs: Infinity,
    maxAiChats: Infinity,
    maxReminders: Infinity
  }
};

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    type: SubscriptionType.FREE,
    name: 'Gratuit',
    description: 'Pour découvrir Anivista',
    price: 0,
    currency: 'CHF',
    interval: 'lifetime',
    features: [
      '1 animal maximum',
      '10 logs de santé',
      '2 conversations IA',
      '5 rappels',
      'Support par email'
    ],
    limits: SUBSCRIPTION_LIMITS[SubscriptionType.FREE]
  },
  {
    type: SubscriptionType.PREMIUM_MONTHLY,
    name: 'Premium Mensuel',
    description: 'Accès complet à toutes les fonctionnalités',
    price: 5,
    currency: 'CHF',
    interval: 'month',
    features: [
      'Animaux illimités',
      'Logs de santé illimités',
      'Conversations IA illimitées',
      'Rappels illimités',
      'Support prioritaire',
      'Fonctionnalités avancées'
    ],
    limits: SUBSCRIPTION_LIMITS[SubscriptionType.PREMIUM_MONTHLY]
  },
  {
    type: SubscriptionType.PREMIUM_YEARLY,
    name: 'Premium Annuel',
    description: 'Économisez 10% avec l\'abonnement annuel',
    price: 50,
    currency: 'CHF',
    interval: 'year',
    features: [
      'Animaux illimités',
      'Logs de santé illimités',
      'Conversations IA illimitées',
      'Rappels illimités',
      'Support prioritaire',
      'Fonctionnalités avancées',
      'Économisez 10% (2 mois gratuits)'
    ],
    limits: SUBSCRIPTION_LIMITS[SubscriptionType.PREMIUM_YEARLY]
  }
];

export const getSubscriptionPlan = (type: SubscriptionType): SubscriptionPlan | undefined => {
  return SUBSCRIPTION_PLANS.find(plan => plan.type === type);
};

export const getSubscriptionLimits = (type: SubscriptionType): SubscriptionLimits => {
  return SUBSCRIPTION_LIMITS[type];
};
